import { Record } from 'immutable';

// @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
const TemplatePreviewRecord = new Record({
  showLoadingOverlay: true,
  modalOpen: false,
  iframeLoading: false,
  iframePaused: false,
  triggerIFrameReload: false
});
export default TemplatePreviewRecord;